var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"d-flex round-unify circle p-2 pointer",class:{
            selected: _vm.selected,
        },on:{"click":_vm.selectWeekday}},[_c('div',{staticClass:"circle-text"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }